module.exports = __webpack_public_path__ + "static/media/IMG_2.d1e6a086.jpg";